import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id FFAA9F2E-96F9-43A3-BC4E-F7562703E6A1
 * name microphone-minus
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-minus.svg
 * tags
 */
export const MicrophoneMinusIcon = createSvgIcon(<><path d="M9,2A3,3 0 0,1 12,5V11A3,3 0 0,1 9,14A3,3 0 0,1 6,11V5A3,3 0 0,1 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4A5,5 0 0,0 9,16A5,5 0 0,0 14,11H16M15,5H23V7H15V5Z" /></>, 'MicrophoneMinusIcon');
export default MicrophoneMinusIcon